import { useMutation, useQueryClient } from 'react-query';

import {
  GROUP_SUBSCRIPTION_KEY,
  UpdateGroupSubscriptionParams,
  updateGroupSubscription,
} from '../utils/backend-api/groupSubscription';

export default function useGroupSubscriptionUpdate() {
  const queryClient = useQueryClient();
  const { mutate, isLoading, isError } = useMutation(
    (params: UpdateGroupSubscriptionParams) => updateGroupSubscription(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GROUP_SUBSCRIPTION_KEY, 'gift']);
      },
    }
  );
  return { mutate, isLoading, isError };
}
